import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { Link } from 'react-router-dom';
import { useMeQuery } from '../../graphql/types';
import { Button } from '../button/button';
import { IconButton } from '../button/icon-button';
import { Container } from '../container/container';
import { FieldGroup } from '../field-group/field-group';
import { SheetHeader } from '../header/sheet-header';
import { SheetContainer } from '../sheet/sheet-container';
import { Status, StatusVariant } from '../status/status';
import CloseSvg from '../svg/close';

interface AccountSheetProps {
  children?: React.ReactNode;
}

export const AccountSheet = ({ children }: AccountSheetProps) => {
  const { isAuthenticated } = useAuth0();
  const me = useMeQuery({
    fetchPolicy: 'cache-first',
  });
  return (
    <SheetContainer
      initial={{ opacity: 0, y: 32 }}
      animate={{ opacity: 1, y: 0, transition: { duration: 0.18 } }}
      exit={{ opacity: 0, y: 32, transition: { duration: 0.18 } }}
    >
      <Container>
        <SheetHeader title="My account">
          <Link to={window.location.pathname}>
            <IconButton>
              <CloseSvg />
            </IconButton>
          </Link>
        </SheetHeader>
        <FieldGroup divider={false} title="Participating in lots">
          <Button variant="primary" as={Link} to="/my-lots">
            See my lots
          </Button>
        </FieldGroup>
        {me.data?.me?.name && me.data?.me?.emailAddress && (
          <FieldGroup title="User details">
            <p>{me.data.me.name}</p>
            <p>{me.data.me.emailAddress}</p>
          </FieldGroup>
        )}

        <FieldGroup title="Bid Status">
          {!isAuthenticated ? (
            <Status variant={StatusVariant.Danger}>Not logged in</Status>
          ) : me.data?.me?.paddle?.number ? (
            <Status variant={StatusVariant.Success}>
              Your paddle number is #{me.data?.me?.paddle?.number}
            </Status>
          ) : (
            <>
              <Status variant={StatusVariant.Warning}>No paddle claimed</Status>
              <Button variant="primary" as={Link} to="/register">
                Claim a paddle
              </Button>
            </>
          )}
        </FieldGroup>
        <FieldGroup>
          <Link to="#terms">
            <Button variant="secondary">Conditions of Business</Button>
          </Link>
        </FieldGroup>

        {me.data?.me?.isAdmin ? (
          <FieldGroup>
            <Link to="/admin/debug">
              <Button variant="secondary">Admin tools</Button>
            </Link>
          </FieldGroup>
        ) : null}

        <FieldGroup>
          <Link to="/logout">
            <Button variant="secondary">Log out</Button>
          </Link>
        </FieldGroup>
      </Container>
    </SheetContainer>
  );
};
